import { Component, OnInit } from '@angular/core';
import { Beneficirani } from './beneficirani';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-beneficirani-modal-update',
  templateUrl: './beneficirani-modal-update.component.html'
})
export class BeneficiraniModalUpdateComponent
 extends BaseModalUpdateComponent<Beneficirani> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Beneficirani>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }
  

  ngOnInit() {
  }

}
